<template>
  <div class="fullheight-layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FullHeightLayout'
}
</script>

<style scoped>
.fullheight-layout {
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// FullHeightLayout.vue?4f73d291